var path = 'app/components/common/forms/templates/horizontalCheckbox.html';
var html = "<div class=\"col-sm-offset-3 col-sm-8\"><formly-transclude></formly-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/forms/templates/horizontalCheckbox.html
// module id = 319
// module chunks = 0